export default __webpack_public_path__ + "static/media/House.633b5494.webp";